<template>
  <div class="Product">
    <ui-navigation></ui-navigation>
    <div class="box clearfix">
      <h4>身份验证中</h4>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/util/eventBus';
import Navigation from '@/components/layout/Navigation.vue';
import generalMix from '@/util/mix/general';
import resultcommons from '../../util/resultcommons';
import commons from '../../util/commons';
import * as types from '../../store/types';
export default {
  name: 'Product',
  props:['tokenbus','type'],
  mixins: [generalMix],
  components: {
    'ui-navigation': Navigation
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  },
  methods:{
    qingqiuInit() {
      resultcommons.apiApilogincalculatetokenid(this,{token:this.tokenbus}).then(app=>{
        if(app.state === 200){
          // 登录操作
          let times = 60 * 60 * 24 * 1000;
          // 写入缓存
          const result = commons.saveTodos('localUser', app.data, times, 0);
          if (result) {
            // 更新本地路由的登录信息
            this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
            this.saveLocaluserFun({bool:true});
            EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
            // 跳转
            if(this.type * 1 === 1){
              // 跳转个人中心
              this.$router.push({ path: '/' })
            }else{
              // 跳转我的订单
              this.$router.push({ path: '/home/order' })
            }
          } else {
            window.swal({
              title: app.message,
              icon: 'warning',
              dangerMode: true
            });
          }
        }else{
          window.swal({
            title: app.message,
            icon: 'warning',
            dangerMode: true
          });
        }
      });
    }
  },
  created() {
    EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
    // 判断是否已经登录
    if(this.localUser){
      this.qingqiuInit();
    }else{
      this.qingqiuInit();
    }
  }
}
</script>

<style scoped lang='less'>
.Product {
  display: flex;
  flex-direction: column;
  height: 100vh;
  div.box{
    flex:1;
    display: flex;
    justify-content: center;
    align-items: center;
    h4{
      margin-top: 100px;
    }
  }
}
@media (max-width: 1200px) {
  .Product{
  }
}
@media (max-width: 992px) {
  .Product{
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collect/Collect.vue